import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "menu"]
  static values = { url: String }

  connect() {
    this.outsideClick = this.outsideClick.bind(this)
    document.addEventListener("click", this.outsideClick)
  }

  disconnect() {
    document.removeEventListener("click", this.outsideClick)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.menuTarget.classList.contains("show")) {
      this.hide()
      return
    }

    if (this.buttonTarget.classList.contains("onprogress")) return

    this.closeAllOthers()

    if (this.hasUrlValue && this.urlValue) {
      this.buttonTarget.classList.add("onprogress")
      let fetchURL = this.urlValue

      // for construct correct url with domain to reudce mismatch
      fetchURL = this.cleanFetchURL(fetchURL)

      fetch(fetchURL, { headers: { Accept: "application/json" } })
        .then(res => res.json())
        .then(data => {
          this.buildList(data)

          // COMMENT THIS LINE OUT TO RE-ENABLE AJAX MODALS LATER:
          this.applyNewWindowFallback()

          this.show()
        })
        .catch(err => console.error("opportunity-givbtn-v3 fetch failed", err))
        .finally(() => this.buttonTarget.classList.remove("onprogress"))
    } else {
      this.show()
    }
  }

  buildList(res) {
    if (!res || !res.object) return

    const lists = {
      opportunity: res.object.opportunity,
      misc: res.object.misc,
    }

    this.menuTarget.innerHTML = ""

    for (const items of Object.values(lists)) {
      if (!items) continue

      for (const item of Object.values(items)) {
        const a = document.createElement("a")
        a.href = item.link
        a.className = `dropdown-item${item.class ? " " + item.class : ""}`
        a.textContent = item.text

        if (item.data) {
          for (const [k, v] of Object.entries(item.data)) {
            a.setAttribute(`data-${k}`, v)
          }
        }

        this.menuTarget.appendChild(a)
      }
    }
  }

  cleanFetchURL(cleanUrl) {
    if (cleanUrl.startsWith("http://") || cleanUrl.startsWith("https://")) {
      const parsed = new URL(cleanUrl)
      cleanUrl = parsed.pathname + parsed.search
    }
    return cleanUrl
  }

  // --- NEW FUNCTION: FALLBACK TO NEW TAB POPUPS ---
  applyNewWindowFallback() {
    this.menuTarget.querySelectorAll("a").forEach(link => {
      // 1. Force the link to open up securely in a new window/tab
      link.setAttribute("target", "_blank")
      link.setAttribute("rel", "noopener noreferrer")

      // 2. Safely strip out modal-ajax classes so global engines don't intercept it
      link.classList.remove("modal-ajax", "log")

      // 3. Make sure clicking the item closes our custom dropdown menu interface smoothly
      // link.addEventListener("click", () => this.hide())
    })
  }

  show() {
    this.menuTarget.classList.add("show")
    this.buttonTarget.classList.add("active")
  }

  hide() {
    this.menuTarget.classList.remove("show")
    this.buttonTarget.classList.remove("active")
  }

  closeAllOthers() {
    document.querySelectorAll(".opportunity-givbtn-v3__menu.show").forEach(menu => {
      if (menu !== this.menuTarget) menu.classList.remove("show")
    })
    document.querySelectorAll(".opportunity-givbtn-v3__toggle.active").forEach(btn => {
      if (btn !== this.buttonTarget) btn.classList.remove("active")
    })
  }

  outsideClick(event) {
    if (!this.menuTarget.classList.contains("show")) return
    if (this.element.contains(event.target)) return
    this.hide()
  }
}